import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
	title: {
		id: "page.users.title",
		defaultMessage: "Users",
	},
	description: {
		id: "page.users.description",
		defaultMessage: "Manage accounts and access.",
	},
	empty: {
		id: "page.users.empty",
		defaultMessage: "No users yet.",
	},
});

export default function UsersPage() {
	const intl = useIntl();

	return (
		<div className="space-y-1 w-full">
			<h1 className="text-lg font-semibold tracking-tight">{intl.formatMessage(messages.title)}</h1>
			<p className="text-sm text-muted-foreground">{intl.formatMessage(messages.description)}</p>
		</div>
	);
}
